<template>
  <div>
    <b-row>
      <!----- SideBar All Design List ---->
      <!-- <sidebarSettingsComponent></sidebarSettingsComponent> -->
      <div class="userdetailside">
        <sidebarForOrdersheet></sidebarForOrdersheet>
      </div>
      <!----- SideBar All Design List End ---->
        
      <div id="overlaymcclist" >
        <div class="loadermcclist"></div>
        <br/>
        Loading...
      </div>

      
      <div class="design-container-details__main" style="width:75%;">
        <h4 class="p-2">MIS Report For Uploaded Plan</h4>
        <div class="col-md-12 ">
            <b-table show-empty
            responsive
            :items="item"
            :fields="fields"
            :bordered="true"
            title="Download Requests Log"
            >
            <div
                slot="table-busy"
                class="text-center text-danger my-2"
            >
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>
            <template slot="uploadedfile" slot-scope="row">
                <p><a :href="row.item.uploaded_file">Uploaded by - {{row.item.full_name}}</a></p>
            </template>

            <template slot="donwlaod" slot-scope="row">
                <i class="fa fa-download" @click="downalodmisforuploadedplan(row.item.uploaded_file)"></i>
            </template>

            </b-table>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
import Vue from 'vue'
import Utils from "@/utils";

import sidebarForOrdersheet from './_sidebarForOrdersheet.vue'
import Datepicker from "vuejs-datepicker";

const axios = require('axios')
export default {
  name: 'misreport_planner',

  components: {
    sidebarForOrdersheet,
    Datepicker
  },
  data() {

    return {
    item:[],
    user_type:'',
    fields:[
        { key: 'season_name', label: 'Season Name' },
        { key: 'uploadedfile', label: 'Uploaded File Name' },
        { key: 'donwlaod', label: 'Download File' },
    ],

    }
  },
  created: function () {
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData);
    this.user_type = userInfo[0].user_type;
    this.getseasonwiseplanlist();
  },

  methods: {

    getseasonwiseplanlist(){

          axios.post(`${CONSTANTS.API_URL}/getseasonwiseplanlist`, {})
        .then(response => {
          document.getElementById("overlay").style.display = "none";

          if (response.data.returnmsg === 'Successful') {
                
                this.item = response.data.returnvalue
                console.log("this.item".this.item)
          }
        })
    },
downalodmisforuploadedplan(file){
     document.getElementById("overlay").style.display = "block";
    const obj = {
        plan_url : file
    }

    axios.post(`${CONSTANTS.API_URL}/downalodmisforuploadedplan`, obj, { responseType: 'arraybuffer' })
    .then(response => {
         document.getElementById("overlay").style.display = "none";
        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: response.headers["content-type"] });

        // Create a download link
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `planner_sheet_${new Date().getTime()}.xlsx`;

        // Simulate a click to trigger the download
        link.click();
    })
    .catch(error => {
        console.error("Error downloading file:", error);
        // Handle error
    });
}


  }
}
</script>
